import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toProgramAwarePath } from './routing';

const BetaLink = ({ to, ...props }) => {
  const location = useLocation();

  if (typeof to === 'string') {
    return <Link to={toProgramAwarePath(to, location.pathname)} {...props} />;
  }

  if (to && typeof to === 'object' && typeof to.pathname === 'string') {
    return (
      <Link
        to={{
          ...to,
          pathname: toProgramAwarePath(to.pathname, location.pathname)
        }}
        {...props}
      />
    );
  }

  return <Link to={to} {...props} />;
};

export default BetaLink;
